import styled from 'styled-components'

export const Aside = styled.aside`
  padding: 16px;
  background-color: #e17055;
  min-height: 100vh;
  max-height: 500vh;
`

export const Filtros = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 8px;
  margin-top: 16px;
`
